import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTabs,{attrs:{"align-with-title":"","background-color":_vm.paletteScanobar.black}},_vm._l((_vm.tabs),function(tab){return _c(VTab,{key:tab.identifier,attrs:{"nuxt":"","to":tab.to}},[_vm._v("\n    "+_vm._s(tab.title)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }